import { Component, OnInit } from '@angular/core';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { RedirectService } from '../shared/redirect.service';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { EmptyStateData, ERROR_DATA } from '../models/error-codes-v2';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomLogger } from '@npm-bbta/bbog-sg-frontend-logs-lib';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';

const logger = new CustomLogger('app-bdb-error-v2', 'red');

@Component({
    selector: 'app-bdb-error-v2',
    templateUrl: './bdb-error-v2.component.html',
})
export class BdbErrorV2Component implements OnInit {
    emptyStateData?: EmptyStateData;

    constructor(
        private readonly bdbSessionStrgService: BdbSessionStrgService,
        private readonly redirectService: RedirectService,
        private readonly domSanitizer: DomSanitizer,
        private readonly route: ActivatedRoute,
    ) {}

    get year() {
        return new Date().getFullYear();
    }

    get description() {
        return this.domSanitizer.bypassSecurityTrustHtml(this.emptyStateData.description);
    }

    ngOnInit(): void {
        const errorCode = this.route.snapshot.queryParams.code;
        const clearData = this.route.snapshot.queryParams.clearData;
        this.emptyStateData = ERROR_DATA[errorCode].emptyStateData;

        logger.log('Error code:', errorCode);
        logger.log('Empty state data:', this.emptyStateData);
        logger.log('Clear data:', clearData);

        if (clearData === 'true') {
            this.clearSessionStorageInformation();
        }
    }

    private clearUserInformation(): void {
        this.bdbSessionStrgService.delete(SessionStorageKeysEnum.IDENTITY_NUMBER);
    }

    private clearIdentityNumberPageVariables(): void {
        this.bdbSessionStrgService.delete('showClientTypeOptions');
        this.bdbSessionStrgService.delete('isClient');
        this.bdbSessionStrgService.delete('clientAuthenticationMethod');
        this.bdbSessionStrgService.delete('identifyTypeAuthentication');
    }

    private clearSessionStorageInformation(): void {
        this.clearUserInformation();
        this.clearIdentityNumberPageVariables();
    }

    handleClick() {
        if (this.emptyStateData.redirectTo) {
            this.redirectService.navigate([this.emptyStateData.redirectTo]);
        } else {
            this.redirectService.redirectToUrl(environment.launcherEndpoint)
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-error-v2/bdb-error-v2.component.ts